import MarketUpdatesContainer from "./MarketUpdatesContainer";
import MarketUpdateStore from "./MarketUpdateStore";

export default MarketUpdateStore(MarketUpdatesContainer);